export default {
    CAUSE_GOD: {
        value: 0,
        title: 'Außergewöhnliche Umstände (außerordentlich schlechtes Wetter, Naturkatastrophen, politische Unruhen, Sicherheitsrisiken)'
    },
    CAUSE_TECHNICAL: {
        value: 1,
        title: 'Technischer Defekt'
    },
    CAUSE_MISC: {
        value: 2,
        title: 'Sonstiges'
    },
    CAUSE_UNKNOWN: {
        value: 3,
        title: 'Ich weiß es nicht/bin mir nicht sicher'
    },
    toArray() {
        return [
            this.CAUSE_GOD,
            this.CAUSE_TECHNICAL,
            this.CAUSE_MISC,
            this.CAUSE_UNKNOWN
        ];
    }
}
